import useSwr from "@/core/composables/swr/useSwr";
import {notificationSequenceApi} from "@/container";
import {PaginationRequest} from "@/core/interfaces/api";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";

/**
 * Composable to get the upcoming sequence messages.
 */
const useUpcomingSequenceMessages = (params: PaginationRequest = {}) => {
    const key = computed(() => {
        return cacheKey('notification-sequence-messages/upcoming', params);
    });

    return useSwr(
        key,
        () => notificationSequenceApi().upcomingMessages(params),
    );
};

export default useUpcomingSequenceMessages;
